import React from "react";
import ProgramDetailsSection from "../../../../components/template/ProgramDetailSection";

const Inhance = () => {
  return (
    <ProgramDetailsSection
      title="INHANCE"
      tagline="Holistic Wellbeing Workshop"
      highlights={[
        "Holistic wellbeing",
        "Healthy lifestyle habits",
        "Long-term vitality",
      ]}
      description="INHANCE is a holistic wellbeing workshop designed to help individuals improve their physical vitality, emotional wellbeing, stress management, and work-life integration through practical and sustainable lifestyle practices."
      duration="2 Days"
      focusAreas={[
        "Physical Health & Vitality",
        "Stress & Energy Management",
        "Emotional Wellbeing",
        "Sustainable Healthy Habits",
        "Work-Life Integration",
      ]}
      outcomes={[
        "Feel healthier, energized, and mentally refreshed.",
        "Build practical habits that improve wellbeing long after the workshop.",
        "Develop a strong foundation for sustainable performance and personal growth.",
      ]}
      images={[
        "../../../cw/CW12.JPG",
         "../../../cw/CW15.JPG",
         "../../../cw/cw5.JPG"
      ]}
    />
  );
};

export default Inhance;